<template lang='pug'>
.content.add-relation-content
  .row.row-relation-header
    .col-md-12
      .header Thêm liên kết tài khoản
      .row.row-search
        .box-relation-search
          .col-md-8.box-search-left
            .form-group(style="margin-top: 0;")
              label.control-label.relation-label Tìm theo tên hiển thị
              input.form-control.search-relation(type='text', placeholder='', v-model='searchText' @keyup="onChange")
              .addons-button-clear(@click="onClear" v-bind:style="clear_search ? 'display:block;' : 'display:none;' ")
          .col-md-4
            .box-btn-relation-search
              button.btn.btn-relation-search(@click="submitSearch") Tìm
  .row.row-list-friend
    .col-md-12.box-list-friend
      .row
        .col-md-2.col-xs-4.box-item-friend(v-for="(o, i) in relations")
          .item-friend
            .img-avt
              img(:src='o.avatar' v-if='o.avatar')
              img(src='../../assets/images/faces/ic_AvatarDefault.svg' v-else)
            .fullname {{o.fullname || 'default'}}
            .list-link
              dropdown(:objSelected='o' :key='componentKey' @onChangeValue="changeValue")
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import itemAdding from '../UserProfile/itemAdding'
import dropdown from './dropdown'
import store from '../../store'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {itemAdding, dropdown, MdNotification},
  data() {
    return {
      searchText: '',
      clear_search: 0,
      relations: null,
      isDropdownOpened: false,
      links: [
        { code: 'GV', name: 'Giáo viên' },
        { code: 'BB', name: 'Bạn bè' },
        { code: 'BDH', name: 'Bạn đồng hành' }
      ],
      selectedValue: 'Thêm bạn',
      select: false,
      offset: 0,
      limit: 20,
      componentKey: 0,
      countSent: 0
    }
  },
  methods: {
    forceRerender() {
      this.componentKey++
    },
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    async changeValue(payload) {
      var result = await this.$apollo.query({
        query: gql(graphql.CHECK_LINK_USER),
        variables: {
          type: payload.value.code,
          uid: this.$store.getters.user,
          uid_requested: payload.sender.id
        }
      })
      var checkSent = await this.$apollo.query({
        query: gql(graphql.CHECK_SENT_REQUEST_EXIST),
        variables: {
          type: payload.value.code,
          uid: this.$store.getters.user,
          uid_requested: payload.sender.id
        }
      })
      if (checkSent && checkSent.data.relation && checkSent.data.relation.length > 0) {
        this.showNotification('Đã gửi yêu cầu ' + payload.value.name + ' với ' + payload.sender.fullname, 'warning', 'top', 'right', 5000)
      } else {
        if (result && (result.data.alias && result.data.alias.length === 0) && (result.data.relation && result.data.relation.length === 0)) {
          this.$apollo.mutate({
            mutation: gql(graphql.CREATE_RELATION),
            variables: {
              object: [{
                user_id_requested: payload.sender.id,
                type: payload.value.code,
                status: 1
              }]
            }
          }).then(res => {
            if (res.data && res.data.insert_relation.affected_rows === 1) {
              this.countSent++
              this.showNotification('Đã gửi liên kết ' + payload.value.name + ' với ' + payload.sender.fullname, 'success', 'top', 'right', 5000)
            }
          })
        } else {
          this.showNotification('Đã liên kết ' + payload.value.name + ' với ' + payload.sender.fullname, 'danger', 'top', 'right', 5000)
        }
      }
    },
    submitSearch() {
      this.$apollo.query({
        query: gql(graphql.GET_USER_LINK),
        variables: {
          uid: this.$store.getters.user,
          keyword: '%' + this.searchText + '%'
        }
      })
      .then((response) => {
        var result = response.data
        for (let i = 0; i < result.v_user_public.length; i++) {
          var flag = false
          var user = result.v_user_public[i]
          if (user && user.UserRequested.length > 0) {
            var requested = user.UserRequested
            for (let j = 0; j < requested.length; j++) {
              if (requested[j].status === 2 && requested[j].user_id_request === store.getters.user) {
                result.v_user_public[i].type = requested[j].type
                result.v_user_public[i].status = requested[j].status
                flag = true
              }
            }
          }
          if (!flag) {
            for (let k = 0; k < result.alias.length; k++) {
              var tmp = result.alias[k].UserRequest
              if (user.id === result.alias[k].id && tmp && tmp.length > 0) {
                for (let v = 0; v < tmp.length; v++) {
                  if (tmp[v].status === 2 && tmp[v].user_id_requested === store.getters.user) {
                    result.v_user_public[i].type = tmp[v].type
                    result.v_user_public[i].status = tmp[v].status
                  }
                }
              }
            }
          }
        }
        // console.log(result)
        this.relations = result.v_user_public
        this.forceRerender()
      })
      .catch((response) =>
        console.error(response)
      )
    },
    onChange(e) {
      if (this.searchText.trim().length) {
        this.clear_search = 1
        if (e.keyCode === 13) this.submitSearch()
      } else this.onClear()
    },
    onClear() {
      this.searchText = ''
      this.clear_search = 0
      this.$apollo.queries.relations.refetch()
    }
  },
  beforeDestroy () {
    // console.log('removeEventListener', this.countSent)
    // document.removeEventListener('backbutton', this.onDeviceReady)
    // this.$store.commit('setSentRequest', this.countSent)
    // this.countSent = 0
  },
  apollo: {
    relations: {
      query: gql(graphql.GET_USER_LINK),
      variables() {
        return {
          uid: this.$store.getters.user,
          offset: this.offset,
          limit: this.limit
        }
      },
      update: data => {
        for (let i = 0; i < data.v_user_public.length; i++) {
          var flag = false
          var user = data.v_user_public[i]
          if (user && user.UserRequested.length > 0) {
            var requested = user.UserRequested
            for (let j = 0; j < requested.length; j++) {
              if (requested[j].status === 2 && requested[j].user_id_request === store.getters.user) {
                data.v_user_public[i].type = requested[j].type
                data.v_user_public[i].status = requested[j].status
                flag = true
              }
            }
          }
          if (!flag) {
            for (let k = 0; k < data.alias.length; k++) {
              var tmp = data.alias[k].UserRequest
              if (user.id === data.alias[k].id && tmp && tmp.length > 0) {
                for (let v = 0; v < tmp.length; v++) {
                  if (tmp[v].status === 2 && tmp[v].user_id_requested === store.getters.user) {
                    data.v_user_public[i].type = tmp[v].type
                    data.v_user_public[i].status = tmp[v].status
                  }
                }
              }
            }
          }
        }
        // console.log(data.v_user_public)
        return data.v_user_public
      }
    }
  }
}
// window.addEventListener('popstate', function (e) {
//   var state = e.state
//   console.log(e.state)
//   if (state !== null) {
//     // load content with ajax
//     console.log('click back')
//   }
// })
</script>

<style lang="scss" scoped>
.add-relation-content {
  padding-top: 20px !important;
}
.row-relation-header {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
  .row-search {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    margin-top: 15px;
    margin-left: 0px;
    margin-right: 0px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    border-radius: 3px;
    display: block;
    position: relative;
    .box-relation-search {
      margin-top: 15px;
      padding-bottom: 0;
      .box-search-left {
        padding-right: 0;
        .relation-label{font-size: 12px;}
        .search-relation {
          padding: 0px 45px 0 16px !important;
        }
        .addons-button-clear {
          display: none; 
          background: url("../../assets/images/register/ic_cancel.png") no-repeat center; 
          position: absolute; 
          right:5px; 
          top:28px;
          width: 40px;  
          height: 34px;
          border-radius: 5px; 
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }
    .box-btn-relation-search {
      padding-top: 10px;
      .btn-relation-search {
        width: 100%;
        height: 48px;
        background: #FFD311;
        color:black;
        text-transform: none;
        font-size: 14px;
        font-family: 'adobe-clean', sans-serif;
        border: 1px solid #FFD311;
        border-radius: 5px;
        box-shadow: none;
      }
    }
  }
}
.row-list-friend {
  margin-top: 15px;
  .box-list-friend {
    .row {
      .box-item-friend {
        border-radius: 3px;
        text-align: center;
        padding: 0 7.5px 15px;
        &:nth-child(6n+1) {padding-left: 15px;}
        &:nth-child(6n) {padding-right: 15px;}
        .item-friend {
          box-shadow: 0px 1px 4px 0 #00000029;
          background: #FFFFFF 0% 0% no-repeat padding-box;
          border: 1px solid #EAEAEA;
          border-radius: 3px;
          opacity: 1;
          .img-avt {
            width: 64px; 
            height: 64px;
            display: inline-block;
            margin-top: 8px;
            border-radius: 50%;
            overflow: hidden;
            img {width: 100%; height: auto;}
          }
          .fullname {
            font-size: 15px; 
            text-align: center; 
            // margin-top: 8px;
            padding: 0 5px;
            min-height: 50px;
          }
          .list-link {
            padding-bottom: 10px;
          }
        }
      }
    }
  }
}
@media (max-width: 991px) {
  
  .box-item-friend {
    .item-friend {
      .list-link{
        .relation-dropdown{
          &.open{
            ul.relation-dropdown-menu{display: block !important;}
            // .dropdown-toggle{background: #f0f !important;}
            // .relation-dropdown-menu{ display: block !important;}
          }
        }
      }
    }
  }
}
@media (max-width: 414px) {
  .add-relation-content {
    padding-top: 30px !important;
  }
  .row-relation-header {
    .row-search {
      .box-relation-search {
        .box-search-left {padding-right: 15px;}
      }
      .box-btn-relation-search {
        padding-top: 0;
        .btn-relation-search {margin-top: 0; margin-bottom: 15px;}
      }
    }
  }
  .row-list-friend {
    .box-list-friend {
      .row {
        .box-item-friend {
          padding-bottom: 7.5px;
          &:nth-child(3n+1) {padding-left: 15px; padding-right: 0;}
          &:nth-child(3n) {padding-right: 15px; padding-left: 0;}
          .item-friend {}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// RelationAdd.vue?295fc00a